<template>
  <hr class="cw-line-wrapper" />
</template>

<script>
import expertviewMixin from './experviewMixin';

export default {
  name: 'cwLineWrapper',
  mixins: [expertviewMixin],
  props: {
    cmpConfig: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    this.$log.debug('cwLineWrapper::created()');
  }
};
</script>

<style lang="scss" scoped>
.cw-line-wrapper {
  border-bottom: 1px solid #becdd7;

  // not needed, element used for mobile UI
  display: none;
  visibility: hidden;
}
</style>
